/**
 * 1.6.7 (D-1.6.7-5) — a person's onboarding from the app: the read the Book sheets share, and the words for the
 * missing pieces. The decision itself is shared/onboarding.ts (the server computes it; nothing is decided here).
 */
import { useQuery } from '@tanstack/react-query';
import type { TFunction } from 'i18next';
import type { OnbPiece, OnboardingResponse } from '@shared/onboarding';
import { apiFetch } from '@/lib/api';

export const onboardingKey = (tenantId: string | null | undefined) => ['onboarding', tenantId ?? ''] as const;

/** GET /api/onboarding?tenantId= — every program's onboarding for one tenant (null inside for a staff unit). */
export function useOnboarding(tenantId: string | null | undefined) {
  return useQuery({
    queryKey: onboardingKey(tenantId),
    queryFn: () => apiFetch<OnboardingResponse>(`/api/onboarding?tenantId=${encodeURIComponent(tenantId!)}`),
    enabled: !!tenantId,
    staleTime: 10_000,
    retry: false,
  });
}

/** "the housekeeping release, the home visit and a phone number or an email address" — in the screen's language. */
export function pieceList(t: TFunction, lang: string, missing: readonly OnbPiece[]): string {
  const words = missing.map((p) => t(`onb167.piece.${p}`));
  try {
    return new Intl.ListFormat(lang.startsWith('es') ? 'es' : 'en', { style: 'long', type: 'conjunction' }).format(words);
  } catch {
    return words.join(', ');
  }
}
